/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { apiSlice } from "./Slices/apiSlice";
import authReducer from "./Slices/authSlice";
import userReducer from "./Slices/userSlice";
import couponReducer from "./Slices/couponSlice"
import categoryReducer from "./Slices/categorySlice";
import offerReducer from "./Slices/offerSlice";
import stateReducer from './Slices/stateSlice'
import resourceReducer from './Slices/resourceSlice'
import areaReducer from  './Slices/areaSlice';
import slotReducer from './Slices/slotSlice';
import calReducer from "./Slices/calSlice";
import freqReducer from './Slices/frequencySlice';
import noOfResReducer from './Slices/noOfResourceSlice'
import requestReducer from './Slices/frequencySlice'
import priceReducer from './Slices/priceSlice'
import chargeReducer from './Slices/chargeSlice';
import noHrsReducer from './Slices/noHrsSlice';
import privReducer from './Slices/privSlice';
import brReducer from './Slices/brSlice'
import brPrivReducer from "./Slices/brPrivSlice";
import addressReducer  from "./Slices/addressSlice";
import reviewReducer from "./Slices/reviewSlice";
import notificationReducer from "./Slices/notificationSlice";

export const RootStore = configureStore({
    reducer: {
      auth: authReducer,
      user: userReducer,
      category: categoryReducer,
      offer : offerReducer,
      state:stateReducer,
      resource:resourceReducer,
      area : areaReducer,
      slot: slotReducer,
      coupon:couponReducer,
      cal: calReducer,
      freq:freqReducer,
      res:noOfResReducer,
      request:requestReducer,
      price:priceReducer,
      charge:chargeReducer,
      hrs:noHrsReducer,
      priv:privReducer,
      br:brReducer,
      brPriv: brPrivReducer,
      // addressSlice: addressReducer,
      address: addressReducer,
      review: reviewReducer,
      notification: notificationReducer,

      [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware),
});

setupListeners(RootStore.dispatch);
